var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"profile-picture pr-3",attrs:{"cols":"auto"}},[_c('ProfilePic',{attrs:{"src":_vm.user.picture,"width":105}})],1),_c('v-col',[_c('div',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")]),_c('FormFields',{attrs:{"fields":_vm.fields}}),_c('UserAvailability')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }